import script from "./UserBindEvse.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserBindEvse.vue?vue&type=script&lang=ts&setup=true"

import "./UserBindEvse.vue?vue&type=style&index=0&id=0a48f8d6&lang=scss"

const __exports__ = script;

export default __exports__